import styled from '@emotion/styled';

export default styled('div')`
  margin-left: 10px;
  display: inline-flex;
  vertical-align: middle;
`;
